import moment from "moment";
export const formatIssueTimeStamp = (timeStamp) => {
  return moment.utc(timeStamp).local().format("MM/DD/YYYY h:mm A");
};



// WEBPACK FOOTER //
// ./src/utils/issueDateUtil.js